import { useState } from "react";

const EMOTE_CATEGORIES = {
  Rostos: [
    "😀",
    "😁",
    "😂",
    "🤣",
    "😊",
    "😍",
    "😘",
    "😎",
    "🤔",
    "😢",
    "😭",
    "😡",
    "🤯",
    "😴",
    "🤗",
    "😳",
  ],
  Gestos: ["👍", "👎", "🙏", "👏", "✌️", "🤝", "💪", "👋", "🤙", "👌"],
  Símbolos: ["❤️", "💔", "💯", "🔥", "✨", "⭐", "💫", "🎉", "🎊", "🎈"],
  Objetos: ["🚀", "💻", "📱", "🎮", "⚽", "🎵", "🎨", "📚", "☕", "🍕"],
};

const EmotesPanel = ({ onSelect }) => {
  const [activeCategory, setActiveCategory] = useState("Rostos");
  const [searchTerm, setSearchTerm] = useState("");

  const filteredEmotes = searchTerm
    ? Object.values(EMOTE_CATEGORIES)
        .flat()
        .filter((emoji) => emoji.includes(searchTerm))
    : EMOTE_CATEGORIES[activeCategory];

  const handleEmoteClick = (emoji) => {
    onSelect(emoji);
    setSearchTerm("");
  };

  return (
    <div className="rounded-lg border border-gray-300 bg-gray-50 dark:border-gray-700 dark:bg-gray-900">
      {/* Categories */}
      {!searchTerm && (
        <div className="flex gap-1 border-b border-gray-200 p-2 dark:border-gray-700">
          {Object.keys(EMOTE_CATEGORIES).map((category) => (
            <button
              key={category}
              type="button"
              onClick={() => setActiveCategory(category)}
              className={`rounded-md px-3 py-1.5 text-sm font-medium transition-colors ${
                activeCategory === category
                  ? "bg-green-500 text-white"
                  : "text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700"
              }`}
            >
              {category}
            </button>
          ))}
        </div>
      )}

      {/* Emotes Grid */}
      <div className="max-h-64 overflow-y-auto p-3">
        {filteredEmotes.length > 0 ? (
          <div className="grid grid-cols-8 gap-1">
            {filteredEmotes.map((emoji, index) => (
              <button
                key={`${emoji}-${index}`}
                type="button"
                onClick={() => handleEmoteClick(emoji)}
                className="flex h-10 w-10 items-center justify-center rounded-md text-2xl transition-all hover:scale-110 hover:bg-gray-100 active:scale-95 dark:hover:bg-gray-700"
                title={emoji}
              >
                {emoji}
              </button>
            ))}
          </div>
        ) : (
          <div className="py-8 text-center text-sm text-gray-500 dark:text-gray-400">
            Nenhum emote encontrado
          </div>
        )}
      </div>
    </div>
  );
};

export default EmotesPanel;
